let nextjsOrigin = ''

/**
 * Set at boot from `app.domains.nextjs`: `getLoaderData` runs outside React, where the router's app
 * state is not reachable.
 */
export const configureNextjsApp = ({ origin }: { origin: string }) => {
    nextjsOrigin = origin
}

export const getNextjsOrigin = () => nextjsOrigin
